"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadJs = exports.isString = exports.isPrerenderPage = exports.isIOSGreaterThan12 = exports.isIOS = exports.isAndroidGreaterThan9 = exports.isAndroid = exports.getZZV = exports.getUnique = exports.getType = exports.getT = exports.getCookie = exports.compareVersion = exports.checkVesionReplay = exports.UA = exports.$isServer = void 0;
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var $isServer = exports.$isServer = typeof window === 'undefined';
var UA = exports.UA = $isServer ? '' : window.navigator.userAgent.toLowerCase();
var isIOS = exports.isIOS = /iphone|ipad|ipod|ios/gi.test(UA);
var isAndroid = exports.isAndroid = /android/gi.test(UA);
var getUnique = exports.getUnique = function getUnique() {
  var d = new Date().getTime();
  var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    return (c == 'x' ? r : r & 0x3 | 0x8).toString(16);
  });
  return uuid;
};
var isIOSGreaterThan12 = exports.isIOSGreaterThan12 = function isIOSGreaterThan12() {
  var _userAgent$match;
  var userAgent = window.navigator.userAgent;
  var iOSVersion = ((_userAgent$match = userAgent.match(/OS (\d+)/)) === null || _userAgent$match === void 0 ? void 0 : _userAgent$match[1]) || 12;
  return isIOS && iOSVersion >= 12;
};
var isAndroidGreaterThan9 = exports.isAndroidGreaterThan9 = function isAndroidGreaterThan9() {
  var _userAgent$match2;
  var userAgent = window.navigator.userAgent;
  var androidVersion = ((_userAgent$match2 = userAgent.match(/Android (\d+)/)) === null || _userAgent$match2 === void 0 ? void 0 : _userAgent$match2[1]) || 9;
  return isAndroid && androidVersion > 9;
};

// 支持replay版本
var checkVesionReplay = exports.checkVesionReplay = function checkVesionReplay() {
  return isIOSGreaterThan12() || isAndroidGreaterThan9();
};
var loadJs = exports.loadJs = function loadJs(url, callback) {
  var hasRandom = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  if ($isServer) return;
  var headTag = document.getElementsByTagName('head')[0];
  var script = document.createElement('script');
  // 加后缀随机数，保证没缓存
  var randomMath = hasRandom ? getUnique() : '1.0.0';
  var currUrl = url + '?v=' + randomMath;
  script.setAttribute('type', 'text/javascript');
  script.setAttribute('async', 'async');
  script.setAttribute('src', currUrl);
  if (typeof callback === 'function') {
    if (script.readyState) {
      script.onreadystatechange = function () {
        if (script.readyState === 'loaded' || script.readyState === 'complete') {
          script.onreadystatechange = null;
          callback();
        }
      };
    } else {
      script.onload = callback;
    }
  }
  if (headTag) {
    headTag.appendChild(script);
  }
};
var getType = exports.getType = function getType(value) {
  return Object.prototype.toString.call(value).slice(8, -1);
};
var getCookie = exports.getCookie = function getCookie(name) {
  if (name) {
    return _jsCookie.default.get(name);
  } else {
    var values = document.cookie.split(/;\s+/);
    var result = {};
    if (values && values.length) {
      values.forEach(function (v) {
        var temp = v.split('=');
        if (temp && temp.length === 2) {
          result[temp[0]] = temp[1];
        }
      });
    }
    return result;
  }
};
var getT = exports.getT = function getT() {
  return getCookie('t') || getCookie('zz_t');
};

/**
   * @function getZZV
   * @description 获取转转app版本号
   * @public
   */
var getZZV = exports.getZZV = function getZZV() {
  var zzv = getCookie('v');
  var hv = getCookie('hv');
  if (~~(UA.indexOf('zzhunter') > 0)) {
    return hv && hv != 'undefined' ? hv : '';
  }
  return zzv && zzv != 'undefined' ? zzv : '';
};

/**
 * 版本号比较
 * @param {string} v1 版本号1，形如"2.2.3"
 * @param {string} v2 版本号2
 * @return {number} 比较结果，[-1 小于 | 0 等于 | 1 大于]
 */
var compareVersion = exports.compareVersion = function compareVersion(v1, v2) {
  var seq1 = v1.split('.').map(function (subVersion) {
    return parseInt(subVersion);
  });
  var seq2 = v2.split('.').map(function (subVersion) {
    return parseInt(subVersion);
  });
  var len1 = seq1.length;
  var len2 = seq2.length;
  var commonLen = Math.min(len1, len2);
  for (var i = 0; i < commonLen; ++i) {
    if (seq1[i] != seq2[i]) return seq1[i] < seq2[i] ? -1 : 1;
  }
  return len1 == len2 ? 0 : len1 < len2 ? -1 : 1;
};

// 是否是预渲染页面
var isPrerenderPage = exports.isPrerenderPage = function isPrerenderPage() {
  var isPreRender = window.location.href.match('isPreRender=1'); // 常规用法
  if (isPreRender) {
    return 1;
  }
  var isZzThan9_1_85 = compareVersion(getZZV(), '10.1.0') >= 0;
  if (isIOS && isZzThan9_1_85 || isAndroid) {
    return Number(typeof window.zzPreRender !== 'undefined');
  }
  return 0;
};
var isString = exports.isString = function isString(value) {
  return getType(value) === 'String';
};